import React from 'react';
import ReactTooltip from 'react-tooltip';
import { createGlobalStyle } from 'styled-components';
import {
  AiChatStarterBubble,
  AiChatStarterBubblesContainer,
  AiConversationStarter,
} from '@/features/ai-agents/chat/starters';
import {
  PROMPT_USE_CASES,
  PromptUseCases,
} from '@/features/editor/widgets/ai-component/use-cases/prompt-use-cases';

const TooltipStyle = createGlobalStyle`
  .ai-starter-tooltip {
    display: grid!important;
    justify-content: center;
    align-items: center;
    align-content: center;
    justify-items: center;
    grid-gap: 0.5rem;
    flex-direction: column;
    box-shadow: 0 4px 5px 0 rgba(105, 122, 231, 0.11),
    0 12px 16px 0 rgba(196, 217, 210, 0.38), 0 1px 5px 0 rgba(0, 0, 0, 0.15);
    border-radius: 1rem!important;
    font-family: "JetBrains Mono",serif;
    opacity: 1!important;
    padding: 1.2rem!important;

    .tooltip-title {
      font-family: 'Eesti', serif;
      font-size: 1.4rem;
      margin-bottom: 0.5rem;
    }

    img {
      object-fit: contain;
      max-height: 40rem;
      min-height: 10rem;
    }
  }
`;

function Tooltip({
  id,
  image,
  title,
}: {
  id: string;
  image: string;
  title: string;
}) {
  return (
    <ReactTooltip
      id={id}
      place="left"
      backgroundColor="#fff"
      textColor="#000"
      className="ai-starter-tooltip"
    >
      <span className="tooltip-title">{title}</span>
      {!!image && <img src={image} alt="" />}
    </ReactTooltip>
  );
}

export const getUseCasesStarters: AiConversationStarter = (
  sendMessage: (prompt: string, send: boolean) => void,
  attachFile: () => void,
  sketch: () => void,
): React.ReactNode => {
  const onClick = (useCase: PromptUseCases) => {
    if (useCase.openSketch) {
      sketch();
      return;
    }
    if (useCase.openImage) {
      attachFile();
    }
    if (useCase.prompt) {
      sendMessage(useCase.prompt, !!useCase.sendPrompt);
    }
  };

  return (
    <>
      <TooltipStyle />
      <AiChatStarterBubblesContainer>
        {PROMPT_USE_CASES.map((useCase) => (
          <>
            <AiChatStarterBubble
              data-tip
              data-for={useCase.title}
              onClick={() => onClick(useCase)}
            >
              {useCase.title}
            </AiChatStarterBubble>
            {useCase.tooltip && (
              <Tooltip
                id={useCase.title}
                image={useCase.tooltip}
                title={useCase.title}
              />
            )}
          </>
        ))}
      </AiChatStarterBubblesContainer>
    </>
  );
};
